// Tiny DOM helpers + the shared toast, used by every module.
export const $ = (selector, ctx = document) => ctx.querySelector(selector);
export const $$ = (selector, ctx = document) => Array.from(ctx.querySelectorAll(selector));

export const data = window.wpsData || { homeUrl: "/", i18n: {} };
export const t = (key) => (data.i18n && data.i18n[key]) || key;

export function readJSON(selector) {
  const el = $(selector);
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return null;
  }
}

export function toast(message) {
  const el = $(".js-toast");
  if (!el) return;
  el.textContent = message;
  el.classList.add("is-shown");
  clearTimeout(el._timer);
  el._timer = setTimeout(() => el.classList.remove("is-shown"), 2600);
}
// Used by newsletter.js, which is a separate bundle.
window.wpsToast = toast;

export function storageGet(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch (e) {
    return fallback;
  }
}

export function storageSet(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    /* storage unavailable — non-fatal */
  }
}
